import {v4 as uuidV4} from 'uuid';

let localMessageNumericId = Number.MAX_SAFE_INTEGER;

type LocalMessageLike = {
  clientId?: string | null;
};

export function createLocalMessageId(): string {
  return uuidV4();
}

export function createLocalMessageNumericId(): number {
  return localMessageNumericId--;
}

export function isLocalMessageId(value: unknown): value is string {
  return typeof value === 'string';
}

export function isLocalMessage(message: LocalMessageLike): boolean {
  return isLocalMessageId(message.clientId);
}
